/**
 * Portlet Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseModel = require('common/base.model');
    var PortletView = require('modules/portlet/portlet.view');
    var device = require('util/device.util');

    module.exports = BaseModel.extend({

        idAttribute: 'portletId',

        getView: PortletView
    }, {
        /**
         * Determines if portlet should be instantiated
         * @param {Object} portletConfig
         * @return {boolean}
         */
        isAvailable: function(portletConfig) {
            return _.isEmpty(portletConfig.enabledDevices) || Boolean(portletConfig.enabledDevices[device.formFactor]);
        }
    });

});
